// ** Routes Imports
// import AppRoutes from './Apps'
// import FormRoutes from './Forms'

// import TablesRoutes from './Tables'
// import ChartMapsRoutes from './ChartsMaps'
// import DashboardRoutes from './Dashboards'
// import UiElementRoutes from './UiElements'
// import ExtensionsRoutes from './Extensions'
// import PageLayoutsRoutes from './PageLayouts' 
// ** Configs
import themeConfig from '@configs/themeConfig'

import PagesRoutesTV from './PagesTv' 

import PagesRoutes from './Pages'

// ** Document title
const TemplateTitle = `%s - ${themeConfig.app.appNameShort}`

// ** Default Route
// const DefaultRoute = 'pages/blog/list'
const DefaultRoute = 'pages/blog/blogs'
// const DefaultRoute = ''

// ** Merge Routes
const Routes = [
  // ...DashboardRoutes,
  // ...AppRoutes,
  ...PagesRoutesTV,
  ...PagesRoutes//,
  // ...UiElementRoutes,
  // ...ExtensionsRoutes,
  // ...PageLayoutsRoutes,
  // ...FormRoutes,
  // ...TablesRoutes,
  // ...ChartMapsRoutes
]

export { DefaultRoute, TemplateTitle, Routes }
